import { ChatBubbleLeftEllipsisIcon } from '@heroicons/react/24/outline';
import React from 'react';

const QuantityCard = ({ QuantityNo }) => {
  return (
    <div className="block p-4 border border-[#DDDDDD] rounded-2xl items-center space-y-3">
      <div className="mb-4 pl-6">
        <div className="flex flex-row justify-between ">
          <div className="tracking-tight text-gray-900 text-[25px] mb-5">
            Quantity {QuantityNo} :
          </div>
          <ChatBubbleLeftEllipsisIcon className="h-6 w-6 mr-3 mt-3 hover:cursor-pointer" />
        </div>
        <div className="flex flex-row justify-between">
          <div className="flex flex-row space-x-3">
            <div className="tracking-tight text-gray-900 text-[25px] font-bold">
              Price Per Unit :
            </div>
            <input
              type="text"
              className="p-2 border border-[#DDDDDD] rounded-2xl w-1/5"
              placeholder="00"
            />
          </div>
          <div className="mt-3 hover:cursor-pointer">
            <div>Add Another Quantity</div>
          </div>
        </div>
      </div>
      <div className="block p-4 pl-6 border border-[#DDDDDD] rounded-2xl items-center">
        <div className="text-gray-900 text-[23px] mb-5">Tooling</div>
        <div className="grid grid-cols-6">
          <div className="text-gray-900 text-[23px] font-bold">Tooling 1 :</div>
          <input
            type="text"
            className="p-2 border border-[#DDDDDD] rounded-2xl w-1/2"
            placeholder="00"
          />
        </div>
      </div>
      <div className="block p-4 pl-6 border border-[#DDDDDD] rounded-2xl items-center">
        <div className="text-gray-900 text-[23px] mb-5">Miscellaneous</div>
        <div className="grid grid-cols-6">
          <div className="text-gray-900 text-[23px] font-bold">Loreum Ip :</div>
          <input
            type="text"
            className="p-2 border border-[#DDDDDD] rounded-2xl w-1/2"
            placeholder="00"
          />
        </div>
      </div>
      <div className="block p-4 pl-6 border border-[#DDDDDD] rounded-2xl items-center">
        <div className="text-gray-900 text-[23px] mb-5">Shipping</div>
        <div className="grid grid-cols-6">
          <div className="text-gray-900 text-[23px] font-bold">Loreum Ip :</div>
          <input
            type="text"
            className="p-2 border border-[#DDDDDD] rounded-2xl w-1/2"
            placeholder="00"
          />
        </div>
      </div>
      <div className="block p-4 pl-6 border border-[#DDDDDD] rounded-2xl items-center space-y-3">
        <div className="text-gray-900 text-[23px] mb-5">
          Verification and Validation
        </div>
        <div className="grid grid-cols-6">
          <div className="text-gray-900 text-[23px] font-bold">Fit :</div>
          <input
            type="text"
            className="p-2 border border-[#DDDDDD] rounded-2xl w-1/2"
            placeholder="00"
          />
        </div>
        <div className="grid grid-cols-6">
          <div className="text-gray-900 text-[23px] font-bold">Form :</div>
          <input
            type="text"
            className="p-2 border border-[#DDDDDD] rounded-2xl w-1/2"
            placeholder="00"
          />
        </div>
        <div className="grid grid-cols-6">
          <div className="text-gray-900 text-[23px] font-bold">Function :</div>
          <input
            type="text"
            className="p-2 border border-[#DDDDDD] rounded-2xl w-1/2"
            placeholder="00"
          />
        </div>
      </div>
      <div className="pl-6">
        <div className="tracking-tight text-gray-900 text-[25px] mb-10">
          Additional Documents
        </div>
      </div>
    </div>
  );
};

export default QuantityCard;
